export const TEST_ID = 'baseNoEquipmentCard';
